import type { FunctionInterpolation } from "@emotion/react";

import type { TransitionDirection } from "../Transition.emotion";

const slideFunction = (
  dir: TransitionDirection,
): "translateX" | "translateY" => {
  if (["from-right", "from-left"].includes(dir)) {
    return "translateX";
  }
  return "translateY";
};
const slideAmount = (
  dir: TransitionDirection,
  phase: "in" | "out" | "stable",
) => {
  if (phase === "stable") return 0;
  if (["from-bottom", "from-right"].includes(dir)) {
    return phase === "in" ? 100 : -50;
  }
  return phase === "in" ? -100 : 50;
};
export const composeSlide = (
  dir: TransitionDirection,
  phase: "in" | "out" | "stable",
) =>
  `${slideFunction(dir)}(${phase === "stable" ? 0 : slideAmount(dir, phase)}%)`;

export const getSlidePhase = (
  type: "push" | "cover",
  stage: "base" | "entering" | "entered" | "exiting" | "exited",
): "in" | "out" | "stable" => {
  if (type === "push") {
    switch (stage) {
      case "base":
      case "entering":
        return "in";
      case "entered":
      case "exiting":
        return "stable";
      case "exited":
        return "out";
    }
  }
  if (stage === "entered") return "stable";
  return "in";
};

export const push: Record<
  "base" | "entered" | "entering" | "exited" | "exiting",
  FunctionInterpolation<string>
> = {
  base: (transform: string) => ({
    opacity: 1,
    transform, //: composeSlide(direction, "in"),
    transitionProperty: "transform, opacity",
    width: "min-content",
    willChange: "transform",
  }),
  entering: (transform: string) => ({
    transform, //: composeSlide(direction, "in"),
  }),
  entered: (transform: string) => ({
    position: "relative",
    transform, //: composeSlide(direction, "stable"),
  }),
  exiting: (transform: string) => ({
    position: "relative",
    transform, //: composeSlide(direction, "stable"),
  }),
  exited: (transform: string) => ({
    opacity: 0,
    transform, //: composeSlide(direction, "out"),
  }),
};
export const cover: Record<
  "base" | "entered" | "entering" | "exited" | "exiting",
  FunctionInterpolation<string>
> = {
  base: (transform: string) => ({
    transform, //: composeSlide(direction, "in"),
    transitionProperty: "transform",
    width: "min-content",
    willChange: "transform, zIndex, position",
    zIndex: 0,
  }),
  entered: (transform: string) => ({
    position: "relative",
    transform, //: composeSlide(direction, "stable"),
    zIndex: 1,
  }),
  entering: (transform: string) => ({
    transform, //: composeSlide(direction, "in"),
    zIndex: 1,
  }),
  exiting: () => ({
    transform: "translate(0, 0)",
  }),
  exited: () => ({
    transform: "translate(0, 0)",
  }),
};
